<template>
    <v-row class="fill-height" no-gutters>
        <v-col cols="12" xs="12" sm="12" class="px-2">
            <v-row no-gutters class="px-2 px-sm-4 mt-5">
                <v-col cols="12" xs="12" sm="">
                    <span class="text-h5 font-weight-thin"
                        >Welcome <span class="font-weight-bold">{{ firstName }}</span></span
                    >
                </v-col>
            </v-row>
            <v-row class="px-2 px-sm-4">
                <v-col cols="12" xs="6" sm="6" class="mb-8">
                    <!-- USER ACCOUNT PENDING -->
                    <v-alert border="left" colored-border color="warning" v-if="GET_currentUser.userStatus === 'PENDING'"
                        ><!-- // TODO CHANGE BACK TO PENDING -->
                        Your account status is currently <strong class="warning--text">PENDING</strong>, please wait while your account is approved.
                        If you require urgent access then please contact {{ GET_currentUser.organisation.organisationName }}
                    </v-alert>
                    <!-- USER ACCOUNT SUSPENDED -->
                    <v-alert border="left" colored-border color="error" v-if="GET_currentUser.userStatus === 'SUSPENDED'">
                        Your account status is currently <strong class="error--text">SUSPENDED</strong>, If you think your account should be active
                        then please contact {{ GET_currentUser.organisation.organisationName }}
                    </v-alert>
                    <!-- USER ACCOUNT REJECTED -->
                    <v-alert border="left" colored-border color="error" v-if="GET_currentUser.userStatus === 'REJECTED'">
                        Your account application has been <strong class="error--text">REJECTED</strong>, If you think your account should be active
                        then please contact {{ GET_currentUser.organisation.organisationName }}
                    </v-alert>
                    <v-col cols="12" class="pa-0 ma-0">
                        <v-row no-gutters> </v-row>
                    </v-col>
                    <v-row no-gutters>
                        <v-col cols="12" xs="12" class="">
                            <v-alert border="left" colored-border color="warning" flat class="pa-2 py-3 py-sm-4 grey lighten-4">
                                <div
                                    @click="MIX_popupNotice('871f87a3bf687b3cad', 'View', true, true)"
                                    class="d-flex align-center "
                                    no-gutters
                                    style="width: 100% !important"
                                >
                                    <v-col cols="12" xs="12" sm="9" class="font-weight-bold secondary--text px-3">
                                        <div class="text-uppercase">Overhead Line Brief</div>
                                        <div class="body-2">Mandatory for Contractors/Visitors Accessing the OLE Area at Canton Depot.</div>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="3" class="mt-3 mt-sm-0 mx-0 text-right d-flex justify-end">
                                        <appbutton
                                            @click.native="MIX_popupNotice('871f87a3bf687b3cad', 'View', true, true)"
                                            label="Open"
                                            type="secondary"
                                            buttonclass="homebutton"
                                            iconclass="white--text"
                                            labelclass="white--text"
                                        />
                                    </v-col>
                                </div>
                            </v-alert>
                        </v-col>

                        <!-- *** Site Access *** -->
                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="my-0">
                            <v-alert
                                class=""
                                border="left"
                                colored-border
                                color="success"
                                v-if="JSON.stringify(access) !== '[]'"
                                @click="MIX_go('/access')"
                            >
                                <v-row no-gutters>
                                    <v-col cols="12" class="d-flex align-center justify-start">
                                        <div><v-icon class="grey--text text--darken-2 text-h3">icons8-warranty</v-icon></div>
                                        <div class="pl-3">Valid Site Access</div>
                                        <v-spacer />
                                        <div>
                                            <appbutton
                                                @click.native="MIX_go('/access')"
                                                label="View"
                                                type="success"
                                                buttonclass="homebutton"
                                                sizeoverride="medium"
                                                iconclass="white--text"
                                                labelclass="white--text"
                                                showlabel="xlOnly"
                                            />
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-alert>
                        </v-col>
                        <!-- *** Visitor Pass *** -->
                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="my-0">
                            <v-alert
                                class=""
                                border="left"
                                colored-border
                                color="success"
                                v-if="JSON.stringify(passes) !== '[]'"
                                @click="MIX_go('/passes')"
                            >
                                <v-row no-gutters class="">
                                    <v-col cols="12" class="d-flex align-center justify-start">
                                        <div><v-icon class="grey--text text--darken-2 text-h3">icons8-security-pass</v-icon></div>
                                        <div class="pl-3">Valid Visitor Pass</div>
                                        <v-spacer />
                                        <div>
                                            <appbutton
                                                @click.native="MIX_go('/passes')"
                                                label="View"
                                                type="success"
                                                buttonclass="homebutton"
                                                sizeoverride="medium"
                                                iconclass="white--text"
                                                labelclass="white--text"
                                                showlabel="xlOnly"
                                            />
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-alert>
                        </v-col>
                        <!-- Swapped In and invalid Induction -->
                        <v-col cols="12" xs="12" class="my-1" v-if="GET_currentUser.userStatus === 'APPROVED'">
                            <v-card flat class="d-flex pa-2 py-3 py-sm-4 grey lighten-4" @click="MIX_go('/induction')">
                                <v-row class="d-flex align-center" no-gutters>
                                    <v-col cols="3" xs="3" sm="2" class="text-center"
                                        ><v-icon class="grey--text text--darken-2 display-3">icons8-survey</v-icon></v-col
                                    >
                                    <v-col cols="9" xs="9" sm="9" class=" font-weight-bold secondary--text px-3">
                                        <div v-if="inductionStatus === 'expired'">
                                            <div class="text-uppercase error--text">Induction has expired</div>
                                            <div class="body-2">
                                                Your induction is
                                                <span class="error--text font-weight-bold"
                                                    ><span v-if="inductionDue">{{ inductionDue }} Days</span> Overdue</span
                                                >, You must carry out an induction before your next visit.
                                            </div>
                                        </div>
                                        <div v-else-if="inductionStatus === 'due'">
                                            <div class="text-uppercase warning--text">Induction is due</div>
                                            <div class="body-2">
                                                You must carry out an induction by {{ MIX_formatDateTime(inductionRenewal, 'x', 'DD-MMM-YY') }} or
                                                before your next visit.
                                            </div>
                                        </div>
                                        <div v-else-if="inductionStatus === 'valid'">
                                            <div class="text-uppercase">View Induction</div>
                                        </div>
                                        <div v-else>
                                            <div class="text-uppercase warning--text">Induction is required</div>
                                            <div class="body-2">All Users are required to complete an induction.</div>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>

                        <!-- Swapp In (Contractors & Visitors - Mobile) -->
                        <v-col
                            v-if="
                                parseInt(GET_currentUser.swappStatus) === 0 && $vuetify.breakpoint.smAndDown && GET_currentUser.userType !== 'STAFF'
                            "
                            cols="12"
                            xs="12"
                            class="my-1"
                        >
                            <v-card flat class="d-flex pa-2 py-3 py-sm-4 grey lighten-4" @click="swappIn()">
                                <v-row class="d-flex align-center" no-gutters>
                                    <v-col cols="3" xs="3" sm="2" class="text-center"
                                        ><v-icon class="grey--text text--darken-2 display-3">icons8-qr-code</v-icon></v-col
                                    >
                                    <v-col cols="9" xs="9" sm="9" class="font-weight-bold secondary--text px-3">
                                        <div class="text-uppercase">SWAPP IN</div>
                                        <div class="body-2">When you arrive at Site you must SWAPP In at a location.</div>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <!-- Swapp In (Contractors & Visitors - Desktop) -->
                        <v-col
                            v-if="parseInt(GET_currentUser.swappStatus) === 0 && $vuetify.breakpoint.mdAndUp && GET_currentUser.userType !== 'STAFF'"
                            cols="12"
                            xs="12"
                            class="my-1"
                        >
                            <v-card flat class="d-flex pa-2 py-3 py-sm-4 grey lighten-4">
                                <v-row class="d-flex align-center" no-gutters>
                                    <v-col cols="3" xs="3" sm="2" class="text-center"
                                        ><v-icon class="grey--text text--darken-2 display-3">icons8-qr-code</v-icon></v-col
                                    >
                                    <v-col cols="9" xs="9" sm="9" class="font-weight-bold secondary--text px-3">
                                        <div class="text-uppercase">SWAPP IN</div>
                                        <div class="body-2">
                                            When you arrive at Site you must SWAPP In at a location. This must be done on a mobile device.
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <!-- Swapp Out (Contractors & Visitors - Mobile) -->
                        <v-col
                            v-if="
                                parseInt(GET_currentUser.swappStatus) === 1 && $vuetify.breakpoint.smAndDown && GET_currentUser.userType !== 'STAFF'
                            "
                            cols="12"
                            xs="12"
                            class="my-1"
                        >
                            <v-card flat class="d-flex pa-2 py-3 py-sm-4 grey lighten-4" @click="MIX_go('/swapp/out')">
                                <v-row class="d-flex align-center" no-gutters>
                                    <v-col cols="3" xs="3" sm="2" class="text-center"
                                        ><v-icon class="grey--text text--darken-2 display-3">icons8-qr-code</v-icon></v-col
                                    >
                                    <v-col cols="9" xs="9" sm="9" class=" font-weight-bold secondary--text px-3">
                                        <div class="text-uppercase">SWAPP OUT</div>
                                        <div class="body-2">When you leave a Location you must SWAPP out of the Location.</div>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <!-- Swapp Out (Contractors & Visitors - Desktop) -->
                        <v-col
                            v-if="parseInt(GET_currentUser.swappStatus) === 1 && $vuetify.breakpoint.mdAndUp && GET_currentUser.userType !== 'STAFF'"
                            cols="12"
                            xs="12"
                            class="my-1"
                        >
                            <v-card flat class="d-flex pa-2 py-3 py-sm-4 grey lighten-4">
                                <v-row class="d-flex align-center" no-gutters>
                                    <v-col cols="3" xs="3" sm="2" class="text-center"
                                        ><v-icon class="grey--text text--darken-2 display-3">icons8-qr-code</v-icon></v-col
                                    >
                                    <v-col cols="9" xs="9" sm="9" class=" font-weight-bold secondary--text px-3">
                                        <div class="text-uppercase">SWAPP OUT</div>
                                        <div class="body-2">
                                            When you leave a Location you must SWAPP out of the Location. This must be done on a mobile device.
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <!-- Apply for a Visitors Pass (Contractos and Visitors) -->
                        <v-col cols="12" xs="12" class="my-1" v-if="['VM', 'VA', 'VU', 'VS', 'CM', 'CA', 'DA'].includes(GET_currentUser.userLevel)">
                            <v-card flat class="d-flex pa-2 py-3 py-sm-4 grey lighten-4" @click="MIX_go('/passes/new')">
                                <v-row class="d-flex align-center" no-gutters>
                                    <v-col cols="3" xs="3" sm="2" class="text-center"
                                        ><v-icon class="grey--text text--darken-2 display-3">icons8-security-pass</v-icon></v-col
                                    >
                                    <v-col cols="9" xs="9" sm="9" class=" font-weight-bold secondary--text px-3">
                                        <div class="text-uppercase">Apply for Visitor Pass</div>
                                        <div class="body-2">As a Visitor you must have a valid Visitor Pass to visit a site.</div>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <!-- Apply for Site Access (Contractors) -->
                        <v-col cols="12" xs="12" class="my-1" v-if="['CM', 'CA', 'DA'].includes(GET_currentUser.userLevel)">
                            <v-card flat class="d-flex pa-2 py-3 py-sm-4 grey lighten-4" @click="MIX_go('/access/new')">
                                <v-row class="d-flex align-center" no-gutters>
                                    <v-col cols="3" xs="3" sm="2" class="text-center"
                                        ><v-icon class="grey--text text--darken-2 display-3">icons8-warranty</v-icon></v-col
                                    >
                                    <v-col cols="9" xs="9" sm="9" class=" font-weight-bold secondary--text px-3">
                                        <div class="text-uppercase">Apply for Site Access</div>
                                        <div class="body-2">As a Contractor you must have a valid Site Access to work on-site.</div>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <!-- Projects -->
                        <v-col cols="12" xs="12" class="my-1">
                            <v-card flat class="d-flex pa-2 py-3 py-sm-4 grey lighten-4" @click="MIX_go('/projects')">
                                <v-row class="d-flex align-center" no-gutters>
                                    <v-col cols="3" xs="3" sm="2" class="text-center"
                                        ><v-icon class="grey--text text--darken-2 display-3">icons8-project</v-icon></v-col
                                    >
                                    <v-col cols="9" xs="9" sm="9" class=" font-weight-bold secondary--text px-3">
                                        <div class="text-uppercase">Projects</div>
                                        <div class="body-2">View Project Details and Upload Documents.</div>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <!-- Incidents -->
                        <v-col cols="12" xs="12" class="my-1">
                            <v-card flat class="d-flex pa-2 py-3 py-sm-4 grey lighten-4" @click="MIX_go('/concerns/new')">
                                <v-row class="d-flex align-center" no-gutters>
                                    <v-col cols="3" xs="3" sm="2" class="text-center"
                                        ><v-icon class="grey--text text--darken-2 display-3">icons8-comments</v-icon></v-col
                                    >
                                    <v-col cols="9" xs="9" sm="9" class=" font-weight-bold secondary--text px-3">
                                        <div class="text-uppercase">REPORT AN INCIDENT</div>
                                        <div class="body-2">Report an Incident with a Project or Site.</div>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                    <br />
                </v-col>
                <v-spacer />
                <v-col class="mb-6 mt-3 mx-0" cols="12" xs="3" sm="3" v-if="$vuetify.breakpoint.mdAndUp && GET_currentUser.userStatus === 'APPROVED'"
                    ><!-- && filteredNotices.length !== 0 -->
                    <div class="text-h7 ml-1 font-weight-bold secondary--text text-decoration-none" @click="MIX_go('/notices')">NOTICE BOARD</div>
                    <v-btn-toggle class="mt-2 ml-0" v-model="noticeMandatory" dense color="secondary" group>
                        <v-btn :value="false" @click="filterNotices(false)">
                            Recent
                        </v-btn>
                        <v-btn v-if="noActionRequired !== 0" :value="true" @click="filterNotices(true)" class="error--text">
                            Action required ({{ noActionRequired }})
                        </v-btn>
                    </v-btn-toggle>
                    <div
                        class="pr-2"
                        style="width: 100% !important; height: 70vh !important; overflow-y: auto !important; overflow-x: hidden !important"
                    >
                        <v-row>
                            <v-col cols="12" xs="12" class="mx-1" v-for="notice in filteredNotices" :key="notice.id">
                                <v-card flat class="pa-5 white">
                                    <div class="d-flex align-start ml-1">
                                        <div class="font-weight-bold text-uppercase grey--text">
                                            <span class="grey--text">{{ notice.noticeName }} </span>
                                            <div class="overline" style="line-height: 15px !important;">
                                                {{ MIX_fromNow(notice.createdDateTime, 'x', false) }}
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="body-2 ml-1">{{ notice.noticeDescription }}</div>
                                        <div class="mt-2 ml-1 body-2 text-left align-center primary--text d-flex">
                                            <span v-if="notice.mandatory === true">ACTION REQUIRED</span>
                                            <v-spacer />
                                            <appbutton
                                                sizeoverride="medium"
                                                label="OPEN"
                                                type="secondary"
                                                iconclass="white--text"
                                                labelclass="white--text"
                                                @click.native="MIX_popupNotice(notice.id, 'View', true, true)"
                                            />
                                        </div>
                                    </div>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
                <v-col class="mb-6 mt-3" cols="12" xs="3" sm="3" v-if="$vuetify.breakpoint.mdAndUp">
                    <router-link to="/todos" class="text-h7 font-weight-bold secondary--text text-decoration-none"
                        >NOTIFICATIONS <span v-if="showNotifications === true">({{ filteredNotifications.length }})</span></router-link
                    ><br />
                    <!-- <appbutton label="SEE MORE" type="secondary" labelclass="white--text" @click.native="MIX_go('/todos')" /> -->
                    <!-- <v-btn-toggle dense color="secondary" group>
                            <v-btn>
                                RECENT
                            </v-btn>
                            <v-btn @click.native="MIX_go('/todos')">
                                    MORE
                            </v-btn>
                        </v-btn-toggle> -->
                    <v-row v-if="showNotifications === true">
                        <v-col cols="12" xs="12" class="" v-for="(notification, index) in filteredNotifications" :key="index">
                            <v-card flat class="pa-5 white">
                                <div class="d-flex align-center body-1 font-weight-bold text-uppercase grey--text">
                                    <span class="grey--text">{{ notification.name }}</span>
                                    <v-spacer />
                                    <div class="caption grey--text" style="line-height: 15px !important;">
                                        {{ MIX_fromNow(notification.createdDateTime, 'x', false) }}
                                    </div>
                                </div>
                                <div class="font-weight-bold text-uppercase grey--text">
                                    <div class="caption" style="line-height: 15px !important;">{{ notification.category }}</div>
                                </div>
                                <div>
                                    <!-- <div v-if="notification.description" class="body-2 mt-2">{{ notification.description }}</div> -->
                                    <div
                                        v-if="notification.link !== undefined && notification.link !== '' && notification.link !== null"
                                        class="mt-0 ml-0 text-left d-flex align-center"
                                    >
                                        <div class="body-2 text-uppercase">{{ notification.linkText }}</div>
                                        <v-spacer />
                                        <appbutton
                                            sizeoverride="medium"
                                            @click.native="updateNotification(notification)"
                                            label="OPEN"
                                            :type="notification.priority"
                                            iconclass="white--text"
                                            labelclass="white--text"
                                        />
                                    </div>
                                    <div v-else class="text-left">
                                        <appbutton
                                            sizeoverride="small"
                                            style="z-index: 3000 !important"
                                            @click.native="updateNotification(notification)"
                                            label="OPEN"
                                            type="grey lighten-4"
                                            iconclass="black--text"
                                            labelclass="grey--text text--darken-1"
                                        />
                                    </div>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
                <!-- App Copyright -->
                <v-col cols="12" class="px-1 copyright">
                    <appcopyright />
                </v-col>
            </v-row>
        </v-col>

        <!-- Site Selection Dialog -->
        <v-dialog v-model="siteSelectionDialog" max-width="500">
            <v-card class="appbackground">
                <div class="primary text-right d-flex align-center" style="height: 50px !important;">
                    <app-text category="popup-title" class="mx-4">Select Site to Swapp Into</app-text>
                    <v-spacer />
                    <appbutton icon="icons8-multiply" type="primary" iconclass="white--text" @click.native="siteSelectionDialog = false" />
                </div>
                <div class="pa-5">
                    <app-text category="popup-text">
                        <p>Please select a site to swapp into:</p>
                    </app-text>
                    <v-select
                        label="Select Site"
                        v-model="selectedSite"
                        required
                        :items="siteSelectionOptions"
                        item-text="name"
                        item-value="id"
                        dense
                        background-color="grey lighten-4"
                        filled
                        hide-details="auto"
                        class="mb-2"
                        :menu-props="{ top: false, offsetY: true }"
                        :attach="true"
                    >
                        <template v-slot:item="data"> {{ data.item.name }} </template>
                        <template v-slot:selection="data"> {{ data.item.name }} </template>
                    </v-select>
                    <app-text category="popup-text" class="mt-2">
                        <p>If you do not see your desired site, you must complete an induction for that site first.</p>
                    </app-text>
                </div>
                <div class="py-5 d-flex justify-center">
                    <appbutton label="Cancel" type="grey ligthen-2" class="mr-1" @click.native="siteSelectionDialog = false" />
                    <appbutton
                        label="Confirm"
                        type="secondary"
                        class=""
                        :disabled="!selectedSite"
                        @click.native="selectSiteAndSwappIn(selectedSite)"
                    />
                </div>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppText from '../components/base/app_text.vue'
import Appbutton from '../components/base/app_button.vue'

export default {
    components: {
        AppText,
        Appbutton
    },
    data: () => ({
        notices: [],
        notifications: [],
        passes: [],
        access: [],
        sites: [],
        accessWhere: [],
        passesWhere: [],
        customWhere: [],
        inductionDone: false,
        inductionStatus: '',
        inductionDue: null,
        inductionRenewal: null,
        noticeMandatory: false,
        readNotices: [],
        filteredNotices: [],
        showNotifications: false,
        siteSelectionDialog: false,
        siteSelectionOptions: [],
        selectedSite: null
    }),
    computed: {
        ...mapGetters({
            GET_currentUser: 'GET_currentUser',
            GET_confirmBoxResult: 'confirmBox_store/GET_confirmBoxResult', // Get Confirm Box Result
            GET_sites: 'GET_sites'
        }),

        filteredNotifications() {
            var t = this
            // sort by date
            var notif = t.MIX_sortByCreatedDateTime(t.notifications)
            // return only first 4 elements
            const filteredNotif = notif.slice(0, 5)
            return filteredNotif
        },

        noActionRequired() {
            var no = 0
            for (var i = 0; i < this.filteredNotices.length; i++) {
                if (this.filteredNotices[i].mandatory === true) {
                    no = no + 1
                }
            }
            return no
        },

        firstName() {
            var splitName = this.GET_currentUser.userName.split(' ')
            return splitName[0]
        }
    },
    watch: {
        GET_confirmBoxResult: {
            handler: async function() {
                var t = this
                if (t.GET_confirmBoxResult.data.collection === 'notifications') {
                    if (t.GET_confirmBoxResult.data.result === 'YES') {
                        var deleteResult = await t.MIX_deleteDocument(t.GET_confirmBoxResult.data.collection, t.GET_confirmBoxResult.data.id)
                        if (deleteResult.code === 1) {
                            t.MIX_alert(1, `${t.collectionItemTitle} Deleted`, deleteResult.data, null)
                        } else {
                            t.MIX_alert(-1, `Error Deleting Notification`, null, deleteResult.error)
                        }
                    }
                } else {
                    // Do nothing
                }
            },
            deep: true
        },

        inductionDone: {
            handler() {
                this.currentUsersInduction()
            },
            deep: true
        },

        GET_currentUser: {
            handler() {
                //console.log('Update')
            }
        },
        deep: true
    },
    methods: {
        ...mapActions({
            ACT_currentUser: 'ACT_currentUser'
        }),

        getNotificationsData: async function() {
            var t = this
            var collection = t.$firebase.db.collection('notifications')
            //console.log('user ' + t.GET_currentUser.id)
            // check for user notifs, if they were not read and if the type is 'App'
            t.customWhere.push(
                { key: 'recipient.userId', operator: '==', value: t.GET_currentUser.id },
                { key: 'read', operator: '==', value: null },
                { key: 'type', operator: 'array-contains', value: 'App' }
            )
            if (JSON.stringify(t.customWhere) !== '[]') {
                for (var i = 0; i < t.customWhere.length; i++) {
                    var query = { field: t.customWhere[i].key, operator: t.customWhere[i].operator, value: t.customWhere[i].value }
                    collection = collection.where(query.field, query.operator, query.value)
                }
            }
            collection.onSnapshot(function(querySnapshot) {
                t.notifications = []
                querySnapshot.forEach(function(doc) {
                    var document = doc.data()
                    document.id = doc.id
                    if (!document.hasOwnProperty('delete')) {
                        t.notifications.push(document)
                    } else {
                        // Do not Show Concern
                    }
                })
            })
            return
        },

        getAlreadyReadNotices() {
            var t = this
            t.$firebase.db
                .collection('readNoticesLogs')
                .where('readBy', '==', t.GET_currentUser.id)
                .onSnapshot(function(querySnapshot) {
                    t.readNotices = []
                    querySnapshot.forEach(function(doc) {
                        var document = doc.data()
                        document.id = doc.id
                        if (!document.hasOwnProperty('delete')) {
                            t.readNotices.push(document)
                            //console.log('here: ' + t.readNotices.length)
                        } else {
                            // Do not Show Notice
                        }
                    })
                })
        },

        getNoticesData() {
            var t = this

            t.$firebase.db
                .collection('notices')
                .where('userTypes', 'array-contains', t.GET_currentUser.userType)
                .where('noticeStatus', '==', 'LIVE')
                .onSnapshot(function(querySnapshot) {
                    t.notices = []
                    querySnapshot.forEach(function(doc) {
                        //console.log(doc.data().noticeName)
                        var document = doc.data()
                        document.id = doc.id
                        if (!document.hasOwnProperty('delete')) {
                            // console.log('document = ' + JSON.stringify(document))
                            // if (!document.readBy.includes(t.GET_currentUser.id)) {
                            t.notices.push(document)
                            // }
                            // } // TODO MAY HAVE TO INCLUDE PUSH HERE
                        } else {
                            // Do not Show Notice
                        }
                    })
                })
        },
        checkInduction() {
            var t = this
            var siteId = this.GET_currentUser.lastSite.siteId
            var inductions = this.GET_currentUser.inductions
            var currentDate = this.$moment().format('x')
            var induction = null
            var inductionStatus = 'notstarted'

            // Filter inductions for current site and get most recent
            if (inductions && inductions.length > 0) {
                var siteInductions = inductions.filter(function(ind) {
                    return ind.site === siteId
                })

                // Sort by date (most recent first)
                if (siteInductions.length > 0) {
                    siteInductions.sort(function(a, b) {
                        return parseInt(b.date) - parseInt(a.date)
                    })

                    // Take the most recent one
                    induction = siteInductions[0]
                }
            }

            // Case 1: Site-specific induction exists
            if (induction) {
                var inductionDate2Y = t
                    .$moment(induction.date, 'x')
                    .add(2, 'years')
                    .format('x')
                var inductionDue = t.$moment(currentDate, 'x').diff(t.$moment(inductionDate2Y, 'x'), 'days')

                t.inductionRenewal = inductionDate2Y
                t.inductionDue = inductionDue

                switch (true) {
                    case inductionDue > 0:
                        inductionStatus = 'expired'
                        break
                    case inductionDue > -90 && inductionDue <= 0:
                        inductionStatus = 'due'
                        break
                    default:
                        inductionStatus = 'valid'
                        break
                }
            }
            // Case 2: Special case for Canton Depot - use global inductionDate
            else if (siteId === 'aeKJ3GotwdOBVoA1f2oY' && this.GET_currentUser.inductionDate && this.GET_currentUser.inductionDate !== '') {
                var userInduction = this.GET_currentUser.inductionDate
                var inductionDate2Y = t
                    .$moment(userInduction, 'x')
                    .add(2, 'years')
                    .format('x')
                var inductionDue = t.$moment(currentDate, 'x').diff(t.$moment(inductionDate2Y, 'x'), 'days')

                t.inductionRenewal = inductionDate2Y
                t.inductionDue = inductionDue

                switch (true) {
                    case inductionDue > 0:
                        inductionStatus = 'expired'
                        break
                    case inductionDue > -90 && inductionDue <= 0:
                        inductionStatus = 'due'
                        break
                    default:
                        inductionStatus = 'valid'
                        break
                }
            }
            // Case 3: No valid induction
            else {
                inductionStatus = 'required'
                t.inductionRenewal = null
                t.inductionDue = null
            }

            t.inductionStatus = inductionStatus
        },
        currentUsersInduction() {
            var t = this

            // if current user is swapped in - go through induction check
            // if (t.GET_currentUser.swappStatus === 1) {
            t.checkInduction()
            // }

            // if (t.GET_currentUser.inductionDate !== '') {
            //     var inductionDate2Y = t
            // 		.$moment(t.GET_currentUser.inductionDate, "x")
            // 		.add(2, "years")
            // 		.format("x");
            // 	var currentDate = t.$moment().format("x");
            // 	var inductionDue = t.$moment(currentDate, "x").diff(t.$moment(inductionDate2Y, "x"), "days"); // 1

            // 	t.inductionRenewal = inductionDate2Y;
            // 	t.inductionDue = inductionDue;

            // 	switch (true) {
            // 		case inductionDue > 0:
            // 			t.inductionStatus = "expired";
            // 			break;
            // 		case inductionDue > -90 && inductionDue < 0:
            // 			t.inductionStatus = "due";
            // 			break;
            //         case inductionDue === '':
            //             t.inductionStatus = "required"
            // 		default:
            // 			t.inductionStatus = "valid";
            // 			break;
            // 	}
            // } else {
            // 	t.inductionStatus = "notstarted";
            // }
        },

        async updateNotification(notification) {
            var t = this

            var readMoment = this.$moment().format('x')
            var updateResult = await t.MIX_updateDocumentFieldsById('notifications', notification.id, { read: readMoment })

            if (updateResult.code === 1) {
                t.MIX_alert(1, 'Notification Updated', updateResult.data, null)
                t.MIX_go(notification.link)
            } else {
                t.MIX_alert(-1, 'ERROR - Could not update Notification', null, updateResult.error)
            }
        },

        deleteItem: function(item) {
            var t = this
            t.MIX_confirmBox({
                show: true,
                collection: 'notifications',
                id: item.id,
                title: `Delete Notification`,
                description: `Are you sure you want to delete notification: <br /><strong>${item.name}</strong>?`,
                width: '400',
                height: '200',
                trueButtonText: 'Yes',
                trueButtonValue: 'YES',
                falseButtonText: 'No',
                falseButtonValue: 'NO'
            })
        },

        filterNotices(mandatory) {
            var t = this

            //check if notices were already read by curr user
            for (var i = t.notices.length - 1; i >= 0; i--) {
                for (var j = 0; j < t.readNotices.length; j++) {
                    if (t.notices[i] && t.notices[i].id === t.readNotices[j].docLink.documentId) {
                        t.notices.splice(i, 1)
                    }
                }
            }

            // sort by date
            var notices = t.MIX_sortByCreatedDateTime(t.notices)

            // filter by mandatory field
            if (mandatory) {
                notices = notices.filter(function(item) {
                    return item.mandatory === true
                })
            }

            // return only first 5 elements
            this.filteredNotices = notices
            t.showNotifications = true
            return this.filteredNotices
        },

        getVisitorPasses: function() {
            return new Promise(async resolve => {
                var t = this

                var where = []
                where.push({ key: 'passStatus', operator: '==', value: 'APPROVED' })
                where.push({ key: 'users', operator: 'array-contains', value: this.GET_currentUser.id })

                var collection = t.$firebase.db.collection('passes')
                for (var i = 0; i < where.length; i++) {
                    var query = { field: where[i].key, operator: where[i].operator, value: where[i].value }
                    collection = collection.where(query.field, query.operator, query.value)
                }

                collection.onSnapshot(function(querySnapshot) {
                    var passes = []
                    querySnapshot.forEach(function(doc) {
                        console.log(doc.id)
                        var document = {}
                        document = doc.data()
                        document.id = doc.id
                        // Exclude Documents with Delete Flag
                        if (!document.hasOwnProperty('delete')) {
                            passes.push(document)
                        }
                    })
                    if (passes.length !== 0) {
                        var validPasses = []
                        var today = t.$moment().format('x')
                        passes.forEach(pass => {
                            if (today > pass.startDate && today < pass.endDate) {
                                validPasses.push(pass)
                            } else {
                            }
                        })
                        t.passes = validPasses
                    } else {
                    }
                })
                resolve()
            })
        },

        getSiteAccess: function() {
            return new Promise(async resolve => {
                var t = this
                var where = []
                where.push({ key: 'accessStatus', operator: '==', value: 'APPROVED' })
                where.push({ key: 'users', operator: 'array-contains', value: this.GET_currentUser.id })

                var collection = t.$firebase.db.collection('access')
                for (var i = 0; i < where.length; i++) {
                    var query = { field: where[i].key, operator: where[i].operator, value: where[i].value }
                    collection = collection.where(query.field, query.operator, query.value)
                }

                collection.onSnapshot(function(querySnapshot) {
                    var access = []
                    querySnapshot.forEach(function(doc) {
                        var document = {}
                        document = doc.data()
                        document.id = doc.id

                        // Exclude Documents with Delete Flag
                        if (!document.hasOwnProperty('delete')) {
                            access.push(document)
                        }
                    })
                    if (access.length !== 0) {
                        var validAccess = []
                        var today = t.$moment().format('x')
                        access.forEach(acc => {
                            if (today > acc.startDate && today < acc.endDate) {
                                validAccess.push(acc)
                            } else {
                            }
                        })
                        t.access = validAccess
                    } else {
                    }
                })
                resolve()
            })
        },

        swappIn() {
            var swappCheckstatus = []
            if (JSON.stringify(this.passes) === '[]' && ['DA'].includes(this.GET_currentUser.userLevel)) {
                swappCheckstatus.push({ falsyMessage: 'You must have a valid Visitor Pass\n', status: false })
            }
            if (
                JSON.stringify(this.access) === '[]' &&
                ['CA', 'CM', 'CS', 'CU'].includes(this.GET_currentUser.userLevel) &&
                JSON.stringify(this.passes) === '[]'
            ) {
                swappCheckstatus.push({ falsyMessage: 'You must have a valid Site Access or Visitor Pass\n', status: false })
            }
            // Removed the induction status check

            if (
                swappCheckstatus.every(function(e) {
                    return e.status === true
                })
            ) {
                // Show site selection dialog before going to swapp/in
                this.showSiteSelectionDialog()
            } else {
                var message = ''
                swappCheckstatus.forEach(function(f) {
                    message = message + f.falsyMessage
                })
                this.MIX_alert(-1, message, null, null)
            }
        },

        showSiteSelectionDialog() {
            const t = this

            const validSites = this.getValidInductionSites() || []

            const filteredSites = validSites
                .map(function(vs) {
                    // No ?? — use explicit null/undefined check
                    const candidateId = vs.siteId !== null && vs.siteId !== undefined ? vs.siteId : vs.id

                    const siteObj = t.sites.find(function(site) {
                        return site.siteId === candidateId
                    })

                    if (!siteObj) return null

                    return {
                        id: siteObj.siteId, // your sites have siteId, not id
                        name: siteObj.siteName + (vs.status === 'due' ? ' (Induction Due)' : ''),
                        status: vs.status
                    }
                })
                .filter(function(x) {
                    return !!x
                })

            if (filteredSites.length === 0) {
                const message =
                    validSites.length === 0
                        ? 'You do not have any valid inductions. You must complete an induction for the site you wish to visit.'
                        : 'You have valid inductions, but none match your known sites. Please check that site IDs align between the induction data and your site list.'
                this.MIX_alert(-1, message, null, null)
                return
            }

            t.siteSelectionOptions = filteredSites // <- use filtered
            t.siteSelectionDialog = true
            t.selectedSite = null
        },
        selectSiteAndSwappIn(site) {
            // Only proceed if a site is selected
            if (!site) return

            // Store the selected site for use in the swapp in process
            this.selectedSite = site

            // Store the selected site ID and name in localStorage for verification in swapp.vue
            localStorage.setItem('selectedSiteId', site)

            // Find the site object to get the name
            const siteObj = this.siteSelectionOptions.find(s => s.id === site)
            if (siteObj) {
                // Check which property contains the site name
                const siteName = siteObj.name || siteObj.siteName
                if (siteName) {
                    localStorage.setItem('selectedSiteName', siteName)
                }
            }

            // Close the dialog
            this.siteSelectionDialog = false

            // Navigate to swapp in page with the selected site
            this.MIX_go('/swapp/in')
        },

        getValidInductionSites() {
            var t = this
            var validSites = []
            var currentDate = t.$moment().format('x')

            // Check inductions
            if (this.GET_currentUser.inductions && this.GET_currentUser.inductions.length > 0) {
                // Process each induction
                this.GET_currentUser.inductions.forEach(induction => {
                    // For each site induction, check if it's valid
                    var inductionDate2Y = t
                        .$moment(induction.date, 'x')
                        .add(2, 'years')
                        .format('x')
                    var inductionDue = t.$moment(currentDate, 'x').diff(t.$moment(inductionDate2Y, 'x'), 'days')

                    // If induction is valid or due (not expired), add to valid sites
                    if (inductionDue <= 0) {
                        validSites.push({
                            id: induction.site,
                            name: induction.siteName || 'Site ' + induction.site,
                            status: inductionDue > -90 ? 'due' : 'valid'
                        })
                    }
                })
            }

            // Special case for Canton Depot
            if (
                !validSites.some(site => site.id === 'aeKJ3GotwdOBVoA1f2oY') &&
                this.GET_currentUser.inductionDate &&
                this.GET_currentUser.inductionDate !== ''
            ) {
                var userInduction = this.GET_currentUser.inductionDate
                var inductionDate2Y = t
                    .$moment(userInduction, 'x')
                    .add(2, 'years')
                    .format('x')
                var inductionDue = t.$moment(currentDate, 'x').diff(t.$moment(inductionDate2Y, 'x'), 'days')

                // If global induction is valid or due (not expired), add Canton Depot to valid sites
                if (inductionDue <= 0) {
                    validSites.push({
                        id: 'aeKJ3GotwdOBVoA1f2oY',
                        name: 'Canton Depot',
                        status: inductionDue > -90 ? 'due' : 'valid'
                    })
                }
            }

            return validSites
        }
    },
    async mounted() {
        // BREADCRUMBS
        var t = this
        var breadcrumbs = []
        breadcrumbs.push({ name: `Home`, path: `/` })
        t.$firebase.db
            .collection('users')
            .doc(t.GET_currentUser.id)
            .onSnapshot(doc => {
                if (doc.exists) {
                    t.key = doc.id
                    var document = doc.data()
                    document.id = doc.id
                    t.ACT_currentUser(document)
                    //console.log('doc exists')
                } else {
                    // console.log('NO SUCH DOCUMENT');//alert("No such document!");
                }
            })
        // * GET SITES
        t.sites = t.GET_sites // STORE SITES IN LOCAL ARRAY
        t.MIX_breadcrumbs(breadcrumbs)
        t.MIX_setPanelLayout(12, 0, false)
        t.getNotificationsData()
        t.getNoticesData()
        t.getAlreadyReadNotices()
        t.currentUsersInduction()
        await t.getVisitorPasses()
        await t.getSiteAccess()
        //t.filterNotices()
        setTimeout(function() {
            t.filterNotices(false)
        }, 1200)
    }
}
</script>

<style></style>
